const state = {
  // 选择的项目分类
  categories: [],
  // 计算后的价格和时间
  evaluation: [],
  // 选中数据
  selectData: []
}

const mutations = {
  /**
   * 获取所有项目类型和子集数据
   * @param {*Object} state
   * @param {*Array} categories
   */
  SETCATES (state, categories) {
    state.categories = categories
  },
  /**
   * 设置选中的数据
   * @param {*} state
   * @param {*} data
   */
  SETSELECTDATA (state, data) {
    state.selectData = data
  },
  /**
   * 保存计算后的价格数据
   * @param {*Object} state
   * @param {*Object} data
   */
  SAVEEVALUATION (state, data) {
    state.evaluation = data
  }
}

export default {
  state,
  mutations
}
